import type { Booking, LessonSession } from '@court-sync/shared';
import { apiGet } from './apiClient';

/**
 * Materialized lesson sessions (owner/coach dashboards). Backed by GET /lesson-sessions.
 */
export const lessonSessionsService = {
  async listByAcademyAndDateRange(
    academyId: string,
    startDateYmd: string,
    endDateYmd: string,
    options?: { notifyableOnly?: boolean }
  ): Promise<LessonSession[]> {
    const response = await apiGet<LessonSession[]>('/lesson-sessions', {
      params: {
        academyId,
        startDate: startDateYmd,
        endDate: endDateYmd,
        ...(options?.notifyableOnly ? { notifyableOnly: 'true' } : {}),
      },
    });
    if (!response.success || !response.data) return [];
    return response.data;
  },

  async getSessionEnrollments(sessionId: string): Promise<Booking[]> {
    const response = await apiGet<Booking[]>(`/lesson-sessions/${sessionId}/enrollments`);
    if (!response.success || !response.data) return [];
    return response.data;
  },
};
